/**
 * Hub empty states, business dashboard chrome, admin nav, quick register, creator partnerships.
 * Merged after user-facing overlay. Not every admin sub-form — nav + core actions + dashboard tabs.
 */

const TRAVEL_HUB = {
  ja: {
    title: '旅行', subtitle: '{city}の旅はどうしますか？',
    packageTitle: 'パッケージツアー', packageDesc: '航空券・宿泊・ツアーがセットの旅程',
    freeTitle: '自由旅行', freeDesc: '宿泊・ツアー・体験を自分で組み合わせ',
    quoteTitle: 'カスタム見積もり', quoteDesc: '人数・予算・日程を伝えれば、専門家が見積もります',
    quoteHint: '迷ったらカスタム見積もりから。', quoteFormTitle: 'カスタム見積もり',
    fieldCity: '行き先', fieldHeadcount: '人数', headcountPh: '旅行者数', fieldBudget: '予算',
    fieldDates: '希望日程', fieldDatesPh: '例: 9月上旬、未定', fieldContact: '連絡先（任意）',
    fieldContactPh: 'ご連絡先', fieldNote: 'メモ', fieldNotePh: '子供連れ、シニア、希望の宿泊など',
    budgetUnder50: '$500未満', budget50to100: '$500〜1,000', budget100to200: '$1,000〜2,000', budgetOver200: '$2,000超',
    submitBtn: '見積もりを依頼', submitting: '送信中…', submitSuccess: '受け付けました。ご連絡します。',
    submitError: '送信できませんでした。もう一度お試しください。', loginRequired: 'ログインしてください。',
  },
  'zh-CN': {
    title: '旅行', subtitle: '想怎么安排{city}的行程？',
    packageTitle: '跟团套餐', packageDesc: '机票+住宿+行程打包',
    freeTitle: '自由行', freeDesc: '自己搭配住宿、行程和体验',
    quoteTitle: '定制报价', quoteDesc: '告诉我们人数、预算和日期，顾问会报价',
    quoteHint: '不确定就先提交定制报价。', quoteFormTitle: '定制报价',
    fieldCity: '目的地', fieldHeadcount: '人数', headcountPh: '出行人数', fieldBudget: '预算',
    fieldDates: '期望日期', fieldDatesPh: '例如 9月初、未定', fieldContact: '联系方式（选填）',
    fieldContactPh: '如何联系您', fieldNote: '备注', fieldNotePh: '带小孩、老人、住宿偏好等',
    budgetUnder50: '$500以下', budget50to100: '$500–1,000', budget100to200: '$1,000–2,000', budgetOver200: '$2,000以上',
    submitBtn: '提交报价', submitting: '发送中…', submitSuccess: '已收到，我们会联系您。',
    submitError: '发送失败，请重试。', loginRequired: '请先登录。',
  },
  'zh-TW': {
    title: '旅行', subtitle: '想怎麼安排{city}的行程？',
    packageTitle: '跟團套裝', packageDesc: '機票+住宿+行程打包',
    freeTitle: '自由行', freeDesc: '自己搭配住宿、行程和體驗',
    quoteTitle: '客製報價', quoteDesc: '告訴我們人數、預算和日期，顧問會報價',
    quoteHint: '不確定就先提交客製報價。', quoteFormTitle: '客製報價',
    fieldCity: '目的地', fieldHeadcount: '人數', headcountPh: '出行人數', fieldBudget: '預算',
    fieldDates: '期望日期', fieldDatesPh: '例如 9月初、未定', fieldContact: '聯絡方式（選填）',
    fieldContactPh: '如何聯絡您', fieldNote: '備註', fieldNotePh: '帶小孩、長輩、住宿偏好等',
    budgetUnder50: '$500以下', budget50to100: '$500–1,000', budget100to200: '$1,000–2,000', budgetOver200: '$2,000以上',
    submitBtn: '提交報價', submitting: '發送中…', submitSuccess: '已收到，我們會聯絡您。',
    submitError: '發送失敗，請重試。', loginRequired: '請先登入。',
  },
  hi: {
    title: 'यात्रा', subtitle: '{city} की यात्रा कैसे प्लान करें?',
    packageTitle: 'पैकेज टूर', packageDesc: 'फ्लाइट + ठहराव + टूर एक साथ',
    freeTitle: 'स्वतंत्र यात्रा', freeDesc: 'ठहराव, टूर और एक्टिविटी खुद चुनें',
    quoteTitle: 'कस्टम कोट', quoteDesc: 'संख्या, बजट और तारीख बताएँ — विशेषज्ञ कोट भेजेगा',
    quoteHint: 'कन्फ्यूज़ हैं तो कस्टम कोट से शुरू करें।', quoteFormTitle: 'कस्टम कोट',
    fieldCity: 'गंतव्य', fieldHeadcount: 'यात्री', headcountPh: 'यात्रियों की संख्या', fieldBudget: 'बजट',
    fieldDates: 'पसंदीदा तारीख', fieldDatesPh: 'जैसे सितंबर की शुरुआत, तय नहीं', fieldContact: 'संपर्क (वैकल्पिक)',
    fieldContactPh: 'कहाँ संपर्क करें?', fieldNote: 'नोट', fieldNotePh: 'बच्चे, सीनियर, ठहराव पसंद आदि',
    budgetUnder50: '$500 से कम', budget50to100: '$500–1,000', budget100to200: '$1,000–2,000', budgetOver200: '$2,000 से अधिक',
    submitBtn: 'कोट माँगें', submitting: 'भेज रहे…', submitSuccess: 'अनुरोध मिल गया। हम संपर्क करेंगे।',
    submitError: 'नहीं भेजा जा सका। फिर कोशिश करें।', loginRequired: 'लॉग इन करें।',
  },
  th: {
    title: 'ท่องเที่ยว', subtitle: 'อยากวางแผนเที่ยว{city}แบบไหน?',
    packageTitle: 'ทัวร์แพ็กเกจ', packageDesc: 'ตั๋วเครื่องบิน+ที่พัก+ทัวร์รวมชุด',
    freeTitle: 'เที่ยวอิสระ', freeDesc: 'เลือกที่พัก ทัวร์ และกิจกรรมเอง',
    quoteTitle: 'ขอใบเสนอราคา', quoteDesc: 'บอกจำนวนคน งบ และวัน แล้วผู้เชี่ยวชาญจะเสนอราคา',
    quoteHint: 'ไม่แน่ใจ เริ่มจากขอใบเสนอราคา', quoteFormTitle: 'ขอใบเสนอราคา',
    fieldCity: 'จุดหมาย', fieldHeadcount: 'จำนวนคน', headcountPh: 'จำนวนผู้เดินทาง', fieldBudget: 'งบประมาณ',
    fieldDates: 'วันที่ต้องการ', fieldDatesPh: 'เช่น ต้นกันยายน ยังไม่ชัวร์', fieldContact: 'ติดต่อ (ไม่บังคับ)',
    fieldContactPh: 'ติดต่อคุณอย่างไร', fieldNote: 'หมายเหตุ', fieldNotePh: 'มีเด็ก ผู้สูงอาย ที่พักที่ชอบ ฯลฯ',
    budgetUnder50: 'ต่ำกว่า $500', budget50to100: '$500–1,000', budget100to200: '$1,000–2,000', budgetOver200: 'มากกว่า $2,000',
    submitBtn: 'ส่งคำขอ', submitting: 'กำลังส่ง…', submitSuccess: 'รับคำขอแล้ว เราจะติดต่อกลับ',
    submitError: 'ส่งไม่สำเร็จ ลองอีกครั้ง', loginRequired: 'กรุณาเข้าสู่ระบบ',
  },
  id: {
    title: 'Wisata', subtitle: 'Bagaimana Anda ingin merencanakan trip {city}?',
    packageTitle: 'Tur paket', packageDesc: 'Tiket + penginapan + tur dalam satu paket',
    freeTitle: 'Perjalanan mandiri', freeDesc: 'Pilih sendiri penginapan, tur, dan aktivitas',
    quoteTitle: 'Permintaan penawaran', quoteDesc: 'Katakan jumlah orang, anggaran, dan tanggal — ahli akan mengirim penawaran',
    quoteHint: 'Ragu? Mulai dari permintaan penawaran.', quoteFormTitle: 'Permintaan penawaran',
    fieldCity: 'Tujuan', fieldHeadcount: 'Jumlah orang', headcountPh: 'Jumlah wisatawan', fieldBudget: 'Anggaran',
    fieldDates: 'Tanggal pilihan', fieldDatesPh: 'mis. awal September, belum pasti', fieldContact: 'Kontak (opsional)',
    fieldContactPh: 'Bagaimana kami menghubungi Anda?', fieldNote: 'Catatan', fieldNotePh: 'Anak, lansia, preferensi menginap, dll.',
    budgetUnder50: 'Di bawah $500', budget50to100: '$500–1,000', budget100to200: '$1,000–2,000', budgetOver200: 'Lebih dari $2,000',
    submitBtn: 'Minta penawaran', submitting: 'Mengirim…', submitSuccess: 'Permintaan diterima. Kami akan menghubungi Anda.',
    submitError: 'Gagal mengirim. Coba lagi.', loginRequired: 'Silakan masuk.',
  },
};

function pack(lang) {
  const D = {
    ja: {
      dashboard: {
        title: '事業者ダッシュボード',
        myBusinesses: 'マイ店舗',
        manage: '管理',
        managePanel: '店舗管理',
        noBusiness: '登録店舗がありません',
        stats: '統計',
        reviews: 'レビュー管理',
        ads: '広告管理',
        notifications: '通知',
        bookings: '予約',
        today: '今日',
        week: '今週',
        month: '今月',
        views: '閲覧',
        header: {
          backAria: '戻る',
          businessFallback: '店舗',
          unreadInquiriesTitle: '未読の問い合わせ',
          exitHomeAria: 'ユーザーホームへ',
          notificationsAria: '通知',
          searchAria: '検索',
        },
        statusToggle: {
          paused: '準備中',
          operating: '営業中',
          processing: '処理中…',
          resumeAction: '営業再開',
          hiringOperating: '採用中',
          hiringPaused: '一時停止',
        },
        more: {
          profileManage: 'プロフィール',
          reviewsManage: 'レビュー',
          ads: '広告',
          shorts: 'AIショート',
          overview: '統計',
          plan: 'プラン',
          settlement: '精算',
          staffManage: 'スタッフ',
          jobsManage: '求人管理',
          exitHome: 'Mingoホーム',
          logout: 'ログアウト',
        },
        fab: {
          createProduct: '商品登録',
          createBooking: '予約を開く',
          createPromo: '共同購入',
          createConsult: '相談を開く',
          createContent: 'ポートフォリオ',
          createJob: '求人を出す',
        },
        catalog: {
          title: '商品管理',
          titleService: 'サービス管理',
          addListing: '+ 商品登録',
          addListingService: '+ サービス登録',
          emptyTitle: 'まだ商品がありません',
          emptyTitleService: 'まだサービスがありません',
        },
        bookingTab: {
          tabPending: '待機',
          tabAllocated: '確定',
          tabCompleted: '完了',
          tabCancelled: 'キャンセル',
          tabByDeparture: '日付別',
        },
        home: {
          priorityTitle: '優先',
          todayTitle: '本日',
          upcomingTitle: '今後の予約',
          upcomingEmpty: '待機中の予約はありません',
          quickTitle: 'ショートカット',
        },
      },
      admin: {
        nav: {
          dashboard: 'ダッシュボード',
          businesses: '店舗管理',
          businessApproval: '店舗承認',
          catalogApproval: '商品・メニュー承認',
          reviews: 'レビュー',
          bookings: '予約',
          settlements: '精算',
          users: 'ユーザー',
          ads: '広告',
          posts: '投稿',
          reports: '通報',
          creators: 'クリエイター',
        },
        approve: '承認',
        reject: '却下',
        suspend: '停止',
        restore: '復元',
        empty: '行がありません',
        summaryTitle: '概要',
      },
      hubs: {
        emptyBusinesses: '登録店舗はまだありません',
        emptyCatalog: '登録商品はまだありません',
        unknownCategory: '不明なカテゴリです',
        hubFallbackTitle: 'ハブ',
        productsSectionTitle: '人気サービス',
        businessesSectionTitle: '店舗',
        businessCountLabel: '{n}店舗',
      },
      quickRegister: {
        title: 'かんたん店舗登録',
        lead: '5項目・約30秒',
        fieldName: '店名 *',
        fieldMajor: '大分類 *',
        fieldSub: '業種（複数可）',
        fieldContact: '連絡先 *',
        fieldPhoto: '代表写真',
        submit: '登録する',
        submitting: '登録中…',
        successToast: '登録しました。プロフィールを埋めると露出が増えます。',
        claimBannerText: 'すでに掲載されていますか？店舗を探す',
      },
      businessClaim: {
        title: '自分の店舗を探す',
        searchBtn: '検索',
        thisIsMine: 'これが私の店です',
        goRegisterNew: '新規登録',
      },
      bizCreator: {
        menuLabel: 'クリエイター提携',
        requests: { title: '提携リクエスト', empty: '待機中のリクエストはありません', reviewBtn: '確認', approveBtn: '承認', rejectBtn: '拒否' },
        claims: { title: '来店確認待ち', confirmBtn: '来店確認', rejectBtn: '拒否', insufficientCredit: 'クレジット不足です。チャージしてから再試行してください。' },
      },
      subscription: { title: '料金プラン', current: '現在のプラン', upgrade: 'アップグレード', free: '無料' },
      business: { listTitle: '店舗', registerCta: '店舗登録', verifiedBadgeAria: '事業者認証', advertiseLikeThis: 'この店舗のように広告しませんか？' },
    },
    'zh-CN': {
      dashboard: {
        title: '商家后台', myBusinesses: '我的店铺', manage: '管理', managePanel: '店铺管理',
        noBusiness: '还没有店铺', stats: '统计', reviews: '评价管理', ads: '广告管理',
        notifications: '通知', bookings: '预约', today: '今天', week: '本周', month: '本月', views: '浏览',
        header: { backAria: '返回', businessFallback: '商家', unreadInquiriesTitle: '未读咨询', exitHomeAria: '回用户首页', notificationsAria: '通知', searchAria: '搜索' },
        statusToggle: { paused: '筹备中', operating: '营业中', processing: '处理中…', resumeAction: '恢复营业', hiringOperating: '招聘中', hiringPaused: '暂停' },
        more: { profileManage: '资料', reviewsManage: '评价', ads: '广告', shorts: 'AI短视频', overview: '统计', plan: '套餐', settlement: '结算', staffManage: '员工', jobsManage: '招聘管理', exitHome: 'Mingo首页', logout: '退出' },
        fab: { createProduct: '发布商品', createBooking: '打开预约', createPromo: '团购', createConsult: '打开咨询', createContent: '作品集', createJob: '发布招聘' },
        catalog: { title: '商品管理', titleService: '服务管理', addListing: '+ 发布商品', addListingService: '+ 发布服务', emptyTitle: '还没有商品', emptyTitleService: '还没有服务' },
        bookingTab: { tabPending: '待处理', tabAllocated: '已确认', tabCompleted: '已完成', tabCancelled: '已取消', tabByDeparture: '按日期' },
        home: { priorityTitle: '优先', todayTitle: '今日', upcomingTitle: '即将到来的预约', upcomingEmpty: '没有待处理预约', quickTitle: '快捷' },
      },
      admin: {
        nav: { dashboard: '总览', businesses: '商家管理', businessApproval: '商家审核', catalogApproval: '商品菜单审核', reviews: '评价', bookings: '预约', settlements: '结算', users: '用户', ads: '广告', posts: '帖子', reports: '举报', creators: '创作者' },
        approve: '通过', reject: '拒绝', suspend: '停用', restore: '恢复', empty: '没有数据', summaryTitle: '总览',
      },
      hubs: { emptyBusinesses: '暂无商家', emptyCatalog: '暂无商品', unknownCategory: '未知分类', hubFallbackTitle: '分类', productsSectionTitle: '热门服务', businessesSectionTitle: '商家', businessCountLabel: '{n}家商家' },
      quickRegister: { title: '快速注册商家', lead: '5项，大约30秒', fieldName: '店名 *', fieldMajor: '大类 *', fieldSub: '业种（可多选）', fieldContact: '联系方式 *', fieldPhoto: '封面照片', submit: '注册', submitting: '注册中…', successToast: '已注册。完善资料可获得更多曝光。', claimBannerText: '已经在名录里？查找店铺' },
      businessClaim: { title: '查找我的店铺', searchBtn: '搜索', thisIsMine: '这是我的店', goRegisterNew: '新注册' },
      bizCreator: { menuLabel: '创作者合作', requests: { title: '合作请求', empty: '没有待处理请求', reviewBtn: '查看', approveBtn: '通过', rejectBtn: '拒绝' }, claims: { title: '待确认到店', confirmBtn: '确认到店', rejectBtn: '拒绝', insufficientCredit: '积分不足，请充值后再试。' } },
      subscription: { title: '订阅套餐', current: '当前套餐', upgrade: '升级', free: '免费' },
      business: { listTitle: '商家', registerCta: '注册商家', verifiedBadgeAria: '已认证商家', advertiseLikeThis: '也想像这家一样投放广告吗？' },
    },
    'zh-TW': {
      dashboard: {
        title: '商家後台', myBusinesses: '我的店鋪', manage: '管理', managePanel: '店鋪管理',
        noBusiness: '還沒有店鋪', stats: '統計', reviews: '評價管理', ads: '廣告管理',
        notifications: '通知', bookings: '預約', today: '今天', week: '本週', month: '本月', views: '瀏覽',
        header: { backAria: '返回', businessFallback: '商家', unreadInquiriesTitle: '未讀諮詢', exitHomeAria: '回使用者首頁', notificationsAria: '通知', searchAria: '搜尋' },
        statusToggle: { paused: '籌備中', operating: '營業中', processing: '處理中…', resumeAction: '恢復營業', hiringOperating: '徵才中', hiringPaused: '暫停' },
        more: { profileManage: '資料', reviewsManage: '評價', ads: '廣告', shorts: 'AI短影音', overview: '統計', plan: '方案', settlement: '結算', staffManage: '員工', jobsManage: '徵才管理', exitHome: 'Mingo首頁', logout: '登出' },
        fab: { createProduct: '刊登商品', createBooking: '打開預約', createPromo: '團購', createConsult: '打開諮詢', createContent: '作品集', createJob: '刊登徵才' },
        catalog: { title: '商品管理', titleService: '服務管理', addListing: '+ 刊登商品', addListingService: '+ 刊登服務', emptyTitle: '還沒有商品', emptyTitleService: '還沒有服務' },
        bookingTab: { tabPending: '待處理', tabAllocated: '已確認', tabCompleted: '已完成', tabCancelled: '已取消', tabByDeparture: '依日期' },
        home: { priorityTitle: '優先', todayTitle: '今日', upcomingTitle: '即將到來的預約', upcomingEmpty: '沒有待處理預約', quickTitle: '快捷' },
      },
      admin: {
        nav: { dashboard: '總覽', businesses: '商家管理', businessApproval: '商家審核', catalogApproval: '商品選單審核', reviews: '評價', bookings: '預約', settlements: '結算', users: '使用者', ads: '廣告', posts: '貼文', reports: '檢舉', creators: '創作者' },
        approve: '通過', reject: '拒絕', suspend: '停用', restore: '恢復', empty: '沒有資料', summaryTitle: '總覽',
      },
      hubs: { emptyBusinesses: '尚無商家', emptyCatalog: '尚無商品', unknownCategory: '未知分類', hubFallbackTitle: '分類', productsSectionTitle: '熱門服務', businessesSectionTitle: '商家', businessCountLabel: '{n}家商家' },
      quickRegister: { title: '快速註冊商家', lead: '5項，約30秒', fieldName: '店名 *', fieldMajor: '大類 *', fieldSub: '業種（可多選）', fieldContact: '聯絡方式 *', fieldPhoto: '封面照片', submit: '註冊', submitting: '註冊中…', successToast: '已註冊。完善資料可獲得更多曝光。', claimBannerText: '已經在名錄裡？尋找店鋪' },
      businessClaim: { title: '尋找我的店鋪', searchBtn: '搜尋', thisIsMine: '這是我的店', goRegisterNew: '新註冊' },
      bizCreator: { menuLabel: '創作者合作', requests: { title: '合作請求', empty: '沒有待處理請求', reviewBtn: '查看', approveBtn: '通過', rejectBtn: '拒絕' }, claims: { title: '待確認到店', confirmBtn: '確認到店', rejectBtn: '拒絕', insufficientCredit: '點數不足，請儲值後再試。' } },
      subscription: { title: '訂閱方案', current: '目前方案', upgrade: '升級', free: '免費' },
      business: { listTitle: '商家', registerCta: '註冊商家', verifiedBadgeAria: '已認證商家', advertiseLikeThis: '也想像這家一樣投放廣告嗎？' },
    },
    hi: {
      dashboard: {
        title: 'बिज़नेस डैशबोर्ड', myBusinesses: 'मेरे व्यवसाय', manage: 'प्रबंधन', managePanel: 'प्रबंधन',
        noBusiness: 'कोई व्यवसाय नहीं', stats: 'आँकड़े', reviews: 'समीक्षाएँ', ads: 'विज्ञापन',
        notifications: 'सूचनाएँ', bookings: 'बुकिंग', today: 'आज', week: 'सप्ताह', month: 'महीना', views: 'व्यू',
        header: { backAria: 'वापस', businessFallback: 'व्यवसाय', unreadInquiriesTitle: 'अपठित पूछताछ', exitHomeAria: 'यूज़र होम', notificationsAria: 'सूचनाएँ', searchAria: 'खोज' },
        statusToggle: { paused: 'तैयार हो रहा', operating: 'खुला', processing: 'प्रोसेस…', resumeAction: 'फिर खोलें', hiringOperating: 'भर्ती', hiringPaused: 'रुका' },
        more: { profileManage: 'प्रोफ़ाइल', reviewsManage: 'समीक्षाएँ', ads: 'विज्ञापन', shorts: 'AI शॉर्ट्स', overview: 'आँकड़े', plan: 'प्लान', settlement: 'भुगतान', staffManage: 'स्टाफ़', jobsManage: 'नौकरियाँ', exitHome: 'Mingo होम', logout: 'लॉग आउट' },
        fab: { createProduct: 'लिस्टिंग जोड़ें', createBooking: 'बुकिंग खोलें', createPromo: 'ग्रुप बाय', createConsult: 'परामर्श', createContent: 'पोर्टफोलियो', createJob: 'नौकरी पोस्ट' },
        catalog: { title: 'लिस्टिंग', titleService: 'सेवाएँ', addListing: '+ लिस्टिंग', addListingService: '+ सेवा', emptyTitle: 'अभी कोई लिस्टिंग नहीं', emptyTitleService: 'अभी कोई सेवा नहीं' },
        bookingTab: { tabPending: 'लंबित', tabAllocated: 'पुष्टि', tabCompleted: 'पूर्ण', tabCancelled: 'रद्द', tabByDeparture: 'तारीख से' },
        home: { priorityTitle: 'प्राथमिकता', todayTitle: 'आज', upcomingTitle: 'आने वाली बुकिंग', upcomingEmpty: 'कोई लंबित बुकिंग नहीं', quickTitle: 'शॉर्टकट' },
      },
      admin: {
        nav: { dashboard: 'डैशबोर्ड', businesses: 'व्यवसाय', businessApproval: 'अनुमोदन', catalogApproval: 'कैटलॉग अनुमोदन', reviews: 'समीक्षाएँ', bookings: 'बुकिंग', settlements: 'सेटलमेंट', users: 'उपयोगकर्ता', ads: 'विज्ञापन', posts: 'पोस्ट', reports: 'रिपोर्ट', creators: 'क्रिएटर' },
        approve: 'स्वीकृत', reject: 'अस्वीकृत', suspend: 'निलंबित', restore: 'बहाल', empty: 'कोई पंक्ति नहीं', summaryTitle: 'सारांश',
      },
      hubs: { emptyBusinesses: 'अभी कोई व्यवसाय नहीं', emptyCatalog: 'अभी कोई उत्पाद नहीं', unknownCategory: 'अज्ञात श्रेणी', hubFallbackTitle: 'हब', productsSectionTitle: 'लोकप्रिय सेवाएँ', businessesSectionTitle: 'व्यवसाय', businessCountLabel: '{n} व्यवसाय' },
      quickRegister: { title: 'त्वरित पंजीकरण', lead: '5 फ़ील्ड, लगभग 30 सेकंड', fieldName: 'नाम *', fieldMajor: 'श्रेणी *', fieldSub: 'प्रकार (बहु)', fieldContact: 'संपर्क *', fieldPhoto: 'फ़ोटो', submit: 'रजिस्टर', submitting: 'रजिस्टर हो रहा…', successToast: 'रजिस्टर हो गया। प्रोफ़ाइल भरें तो ज़्यादा दिखेगा।', claimBannerText: 'पहले से सूची में? व्यवसाय खोजें' },
      businessClaim: { title: 'मेरा व्यवसाय खोजें', searchBtn: 'खोजें', thisIsMine: 'यह मेरा है', goRegisterNew: 'नया रजिस्टर' },
      bizCreator: { menuLabel: 'क्रिएटर साझेदारी', requests: { title: 'अनुरोध', empty: 'कोई लंबित अनुरोध नहीं', reviewBtn: 'देखें', approveBtn: 'स्वीकृत', rejectBtn: 'अस्वीकृत' }, claims: { title: 'विज़िट पुष्टि बाकी', confirmBtn: 'विज़िट पुष्टि', rejectBtn: 'अस्वीकृत', insufficientCredit: 'क्रेडिट कम हैं। टॉप-अप करें।' } },
      subscription: { title: 'प्लान', current: 'वर्तमान प्लान', upgrade: 'अपग्रेड', free: 'मुफ़्त' },
      business: { listTitle: 'व्यवसाय', registerCta: 'व्यवसाय रजिस्टर', verifiedBadgeAria: 'सत्यापित', advertiseLikeThis: 'इस व्यवसाय की तरह विज्ञापन करना चाहते हैं?' },
    },
    th: {
      dashboard: {
        title: 'แดชบอร์ดร้าน', myBusinesses: 'ร้านของฉัน', manage: 'จัดการ', managePanel: 'จัดการร้าน',
        noBusiness: 'ยังไม่มีร้าน', stats: 'สถิติ', reviews: 'รีวิว', ads: 'โฆษณา',
        notifications: 'การแจ้งเตือน', bookings: 'การจอง', today: 'วันนี้', week: 'สัปดาห์นี้', month: 'เดือนนี้', views: 'ยอดดู',
        header: { backAria: 'กลับ', businessFallback: 'ร้าน', unreadInquiriesTitle: 'ข้อความยังไม่อ่าน', exitHomeAria: 'หน้าผู้ใช้', notificationsAria: 'การแจ้งเตือน', searchAria: 'ค้นหา' },
        statusToggle: { paused: 'กำลังเตรียม', operating: 'เปิดทำการ', processing: 'กำลังทำ…', resumeAction: 'เปิดอีกครั้ง', hiringOperating: 'รับสมัคร', hiringPaused: 'หยุดชั่วคราว' },
        more: { profileManage: 'โปรไฟล์', reviewsManage: 'รีวิว', ads: 'โฆษณา', shorts: 'ช็อต AI', overview: 'สถิติ', plan: 'แพ็กเกจ', settlement: 'การจ่าย', staffManage: 'พนักงาน', jobsManage: 'จัดการงาน', exitHome: 'หน้าแรก Mingo', logout: 'ออกจากระบบ' },
        fab: { createProduct: 'ลงสินค้า', createBooking: 'เปิดจอง', createPromo: 'ซื้อร่วม', createConsult: 'เปิดปรึกษา', createContent: 'ผลงาน', createJob: 'ลงรับสมัคร' },
        catalog: { title: 'สินค้า', titleService: 'บริการ', addListing: '+ ลงสินค้า', addListingService: '+ ลงบริการ', emptyTitle: 'ยังไม่มีสินค้า', emptyTitleService: 'ยังไม่มีบริการ' },
        bookingTab: { tabPending: 'รอดำเนินการ', tabAllocated: 'ยืนยันแล้ว', tabCompleted: 'เสร็จ', tabCancelled: 'ยกเลิก', tabByDeparture: 'ตามวันที่' },
        home: { priorityTitle: 'ด่วน', todayTitle: 'วันนี้', upcomingTitle: 'จองที่จะมา', upcomingEmpty: 'ไม่มีจองรอดำเนินการ', quickTitle: 'ทางลัด' },
      },
      admin: {
        nav: { dashboard: 'แดชบอร์ด', businesses: 'ร้านค้า', businessApproval: 'อนุมัติร้าน', catalogApproval: 'อนุมัติสินค้า', reviews: 'รีวิว', bookings: 'การจอง', settlements: 'การจ่าย', users: 'ผู้ใช้', ads: 'โฆษณา', posts: 'โพสต์', reports: 'รายงาน', creators: 'ครีเอเตอร์' },
        approve: 'อนุมัติ', reject: 'ปฏิเสธ', suspend: 'ระงับ', restore: 'คืนค่า', empty: 'ไม่มีรายการ', summaryTitle: 'ภาพรวม',
      },
      hubs: { emptyBusinesses: 'ยังไม่มีร้าน', emptyCatalog: 'ยังไม่มีสินค้า', unknownCategory: 'ไม่รู้จักหมวด', hubFallbackTitle: 'ฮับ', productsSectionTitle: 'บริการยอดนิยม', businessesSectionTitle: 'ร้านค้า', businessCountLabel: '{n} ร้าน' },
      quickRegister: { title: 'ลงทะเบียนร้านเร็ว', lead: '5 ช่อง ประมาณ 30 วินาที', fieldName: 'ชื่อร้าน *', fieldMajor: 'หมวดหลัก *', fieldSub: 'ประเภท (หลายอันได้)', fieldContact: 'ติดต่อ *', fieldPhoto: 'รูปปก', submit: 'ลงทะเบียน', submitting: 'กำลังลงทะเบียน…', successToast: 'ลงทะเบียนแล้ว กรอกโปรไฟล์เพื่อให้เห็นมากขึ้น', claimBannerText: 'มีในรายชื่อแล้ว? ค้นหาร้าน' },
      businessClaim: { title: 'ค้นหาร้านของฉัน', searchBtn: 'ค้นหา', thisIsMine: 'นี่คือร้านฉัน', goRegisterNew: 'ลงทะเบียนใหม่' },
      bizCreator: { menuLabel: 'พันธมิตรครีเอเตอร์', requests: { title: 'คำขอร่วมมือ', empty: 'ไม่มีคำขอค้าง', reviewBtn: 'ดู', approveBtn: 'อนุมัติ', rejectBtn: 'ปฏิเสธ' }, claims: { title: 'รอยืนยันการมา', confirmBtn: 'ยืนยันการมา', rejectBtn: 'ปฏิเสธ', insufficientCredit: 'เครดิตไม่พอ กรุณาเติมแล้วลองใหม่' } },
      subscription: { title: 'แพ็กเกจ', current: 'แพ็กเกจปัจจุบัน', upgrade: 'อัปเกรด', free: 'ฟรี' },
      business: { listTitle: 'ร้านค้า', registerCta: 'ลงทะเบียนร้าน', verifiedBadgeAria: 'ร้านยืนยันแล้ว', advertiseLikeThis: 'อยากโฆษณาแบบร้านนี้ไหม?' },
    },
    id: {
      dashboard: {
        title: 'Dasbor bisnis', myBusinesses: 'Bisnis saya', manage: 'Kelola', managePanel: 'Kelola bisnis',
        noBusiness: 'Belum ada bisnis', stats: 'Statistik', reviews: 'Ulasan', ads: 'Iklan',
        notifications: 'Notifikasi', bookings: 'Pemesanan', today: 'Hari ini', week: 'Minggu ini', month: 'Bulan ini', views: 'Tayangan',
        header: { backAria: 'Kembali', businessFallback: 'Bisnis', unreadInquiriesTitle: 'Pesan belum dibaca', exitHomeAria: 'Beranda pengguna', notificationsAria: 'Notifikasi', searchAria: 'Cari' },
        statusToggle: { paused: 'Persiapan', operating: 'Buka', processing: 'Memproses…', resumeAction: 'Buka lagi', hiringOperating: 'Merekrut', hiringPaused: 'Jeda' },
        more: { profileManage: 'Profil', reviewsManage: 'Ulasan', ads: 'Iklan', shorts: 'Shorts AI', overview: 'Statistik', plan: 'Paket', settlement: 'Pencairan', staffManage: 'Staf', jobsManage: 'Kelola lowongan', exitHome: 'Beranda Mingo', logout: 'Keluar' },
        fab: { createProduct: 'Tambah listing', createBooking: 'Buka pemesanan', createPromo: 'Beli bersama', createConsult: 'Buka konsultasi', createContent: 'Portofolio', createJob: 'Pasang lowongan' },
        catalog: { title: 'Listing', titleService: 'Layanan', addListing: '+ Listing', addListingService: '+ Layanan', emptyTitle: 'Belum ada listing', emptyTitleService: 'Belum ada layanan' },
        bookingTab: { tabPending: 'Menunggu', tabAllocated: 'Terkonfirmasi', tabCompleted: 'Selesai', tabCancelled: 'Dibatalkan', tabByDeparture: 'Per tanggal' },
        home: { priorityTitle: 'Prioritas', todayTitle: 'Hari ini', upcomingTitle: 'Pemesanan berikutnya', upcomingEmpty: 'Tidak ada pemesanan menunggu', quickTitle: 'Pintasan' },
      },
      admin: {
        nav: { dashboard: 'Dasbor', businesses: 'Bisnis', businessApproval: 'Persetujuan bisnis', catalogApproval: 'Persetujuan katalog', reviews: 'Ulasan', bookings: 'Pemesanan', settlements: 'Pencairan', users: 'Pengguna', ads: 'Iklan', posts: 'Posting', reports: 'Laporan', creators: 'Kreator' },
        approve: 'Setujui', reject: 'Tolak', suspend: 'Tangguhkan', restore: 'Pulihkan', empty: 'Tidak ada baris', summaryTitle: 'Ringkasan',
      },
      hubs: { emptyBusinesses: 'Belum ada bisnis', emptyCatalog: 'Belum ada produk', unknownCategory: 'Kategori tidak dikenal', hubFallbackTitle: 'Hub', productsSectionTitle: 'Layanan populer', businessesSectionTitle: 'Bisnis', businessCountLabel: '{n} bisnis' },
      quickRegister: { title: 'Daftar bisnis cepat', lead: '5 kolom, sekitar 30 detik', fieldName: 'Nama *', fieldMajor: 'Kategori *', fieldSub: 'Jenis (bisa banyak)', fieldContact: 'Kontak *', fieldPhoto: 'Foto sampul', submit: 'Daftar', submitting: 'Mendaftar…', successToast: 'Terdaftar. Lengkapi profil agar lebih terlihat.', claimBannerText: 'Sudah terdaftar? Cari bisnis' },
      businessClaim: { title: 'Cari bisnis saya', searchBtn: 'Cari', thisIsMine: 'Ini milik saya', goRegisterNew: 'Daftar baru' },
      bizCreator: { menuLabel: 'Kemitraan kreator', requests: { title: 'Permintaan', empty: 'Tidak ada permintaan menunggu', reviewBtn: 'Tinjau', approveBtn: 'Setujui', rejectBtn: 'Tolak' }, claims: { title: 'Kunjungan menunggu konfirmasi', confirmBtn: 'Konfirmasi kunjungan', rejectBtn: 'Tolak', insufficientCredit: 'Kredit kurang. Isi saldo lalu coba lagi.' } },
      subscription: { title: 'Paket langganan', current: 'Paket saat ini', upgrade: 'Upgrade', free: 'Gratis' },
      business: { listTitle: 'Bisnis', registerCta: 'Daftar bisnis', verifiedBadgeAria: 'Bisnis terverifikasi', advertiseLikeThis: 'Ingin beriklan seperti bisnis ini?' },
    },
  };
  return D[lang] || {};
}

export function getOpsFacingOverlay(lang) {
  const base = pack(lang);
  if (!base || Object.keys(base).length === 0) return {};
  return { ...base, travelHub: TRAVEL_HUB[lang] || {} };
}
